"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFactEntities = exports.isCustomerTask = exports.fromFactEntities = void 0;
const _1 = require(".");
const tasks_1 = require("../../tasks");
const constants_1 = require("../../tasks/constants");
const fromFactEntities = (propertyFact, customerFact) => {
    return Object.keys(tasks_1.TaskDetails).reduce((all, k) => {
        if ((0, exports.isCustomerTask)(k)) {
            all[k] = customerFact.context[k];
        }
        else {
            all[k] = propertyFact.context[k];
        }
        return all;
    }, {});
};
exports.fromFactEntities = fromFactEntities;
const isCustomerTask = (task) => {
    return constants_1.CUSTOMER_TASKS.includes(task);
};
exports.isCustomerTask = isCustomerTask;
const toFactEntities = (propertyId, customerId, taskState) => {
    const customer = {};
    const property = {};
    Object.keys(taskState).forEach((k) => {
        if ((0, exports.isCustomerTask)(constants_1.Tasks[k])) {
            customer[k] = taskState[k];
        }
        else {
            property[k] = taskState[k];
        }
    });
    return {
        property: {
            property: propertyId,
            type: _1.PROPERTY_COMPLETENESS_FACT,
            context: property
        },
        customer: {
            account: customerId,
            type: _1.CUSTOMER_COMPLETENESS_FACT,
            context: customer
        }
    };
};
exports.toFactEntities = toFactEntities;
//# sourceMappingURL=helpers.js.map